// document.addEventListener("DOMContentLoaded",()=>{

// const root=document.querySelector(".bundle-selector");
// if(!root) return;

// const slider=root.querySelector(".bundle-slider");
// const steps=[...root.querySelectorAll(".bundle-steps span")];
// const items=[...root.querySelectorAll(".bundle-item")];

// const totalItemsEl=root.querySelector("[data-total-items]");
// const totalPriceEl=root.querySelector("[data-total-price]");

// const packCountEl=root.querySelector("[data-pack-count]");
// const packLabelEl=root.querySelector("[data-pack-label]");
// const packMessageEl=root.querySelector("[data-pack-message]");
// const packDiscountEl=root.querySelector("[data-pack-discount]");

// let selectedPack=steps[0].dataset;

// function animateSlider(index){
//  const percent=(index/(steps.length-1))*100;
//  slider.style.background=
//  `linear-gradient(90deg,#000 ${percent}%,#e5e5e5 ${percent}%)`;
// }

// function updatePackUI(index){

//  const step=steps[index];
//  selectedPack=step.dataset;

//  slider.value=index;

//  packCountEl.textContent=selectedPack.count;
//  packLabelEl.textContent=selectedPack.label;
//  packMessageEl.textContent=selectedPack.message || "";
//  packDiscountEl.textContent=`Save ${selectedPack.discount}%`;

//  if(selectedPack.color){
//    packDiscountEl.style.background=selectedPack.color;
//  }

//  steps.forEach(s=>s.classList.remove("active"));
//  step.classList.add("active");

//  animateSlider(index);
// }

// function findClosestPack(total){

//  let closestIndex=0;
//  let smallestDiff=Infinity;

//  steps.forEach((step,index)=>{
//    const packCount=parseInt(step.dataset.count);
//    const diff=Math.abs(total-packCount);

//    if(diff<smallestDiff){
//      smallestDiff=diff;
//      closestIndex=index;
//    }
//  });

//  return closestIndex;
// }

// function calculateTotal(){

//  let totalItems=0;
//  let totalPrice=0;

//  items.forEach(item=>{
//    const count=parseInt(item.querySelector(".count").textContent);
//    const price=parseFloat(item.dataset.price);

//    totalItems+=count;
//    totalPrice+=count*price;
//  });

//  updatePackUI(findClosestPack(totalItems));

//  const discount=parseFloat(selectedPack.discount||0);
//  const discountedPrice=totalPrice-(totalPrice*discount/100);

//  totalItemsEl.textContent=totalItems;

//  if(window.Shopify){
//    totalPriceEl.textContent=
//    Shopify.formatMoney(discountedPrice,"{{ shop.money_format }}");
//  }
// }

// items.forEach(item=>{
//  const plus=item.querySelector(".plus");
//  const minus=item.querySelector(".minus");
//  const countEl=item.querySelector(".count");

//  plus.addEventListener("click",()=>{
//    countEl.textContent=parseInt(countEl.textContent)+1;
//    calculateTotal();
//  });

//  minus.addEventListener("click",()=>{
//    countEl.textContent=Math.max(0,parseInt(countEl.textContent)-1);
//    calculateTotal();
//  });
// });

// slider.addEventListener("input",()=>{
//  updatePackUI(parseInt(slider.value));
// });

// root.querySelector(".bundle-add").addEventListener("click",()=>{

//  const cartItems=[];

//  items.forEach(item=>{
//    const qty=parseInt(item.querySelector(".count").textContent);
//    const id=item.dataset.id;
//    if(qty>0){
//      cartItems.push({id:id,quantity:qty});
//    }
//  });

//  if(!cartItems.length) return;

//  fetch("/cart/add.js",{
//    method:"POST",
//    headers:{ "Content-Type":"application/json" },
//    body:JSON.stringify({items:cartItems})
//  }).then(()=>location.reload());

// });

// updatePackUI(0);
// animateSlider(0);

// });


document.addEventListener("DOMContentLoaded",()=>{

    const items = document.querySelectorAll(".acc-item");
  
    items.forEach(item=>{
  
      const header = item.querySelector(".acc-header");
  
      header.addEventListener("click",()=>{
  
        /* CLOSE OTHERS (like screenshot behavior) */
        items.forEach(i=>{
          if(i !== item){
            i.classList.remove("active");
          }
        });
  
        item.classList.toggle("active");
  
      });
  
    });
  
  });
  
  
  
  document.addEventListener("click", function(e){

    const trigger = e.target.closest("[data-drawer-trigger]");
    if(trigger){
      const id = trigger.dataset.drawerTrigger;
      const drawer = document.getElementById("Drawer-" + id);
      if (!drawer) return;

      let factIndex = trigger.dataset.factIndex;
      if (factIndex === undefined) {
        const block = trigger.closest(".clinical-block");
        const scroll = block?.querySelector(".clinical-label-scroll");
        if (scroll) {
          const scrollRect = scroll.getBoundingClientRect();
          const centerX = scrollRect.left + scrollRect.width / 2;
          const items = scroll.querySelectorAll(".clinical-label-item:not([aria-hidden])");
          let minDist = Infinity;
          items.forEach(function(item) {
            const rect = item.getBoundingClientRect();
            const dist = Math.abs(centerX - (rect.left + rect.width / 2));
            if (dist < minDist) {
              minDist = dist;
              factIndex = item.dataset.factIndex;
            }
          });
        }
        if (factIndex === undefined) factIndex = "0";
      }

      drawer.querySelectorAll("[data-fact-panel]").forEach(function(panel) {
        panel.hidden = panel.dataset.factPanel !== factIndex;
      });
      drawer.classList.add("active");
    }

    if(e.target.matches("[data-close]")){
      e.target.closest(".clinical-drawer").classList.remove("active");
    }

  });

  class SnakeBorderButton extends HTMLElement {
    constructor() {
      super();
  
      const checkoutButton = this.querySelector('#CartDrawer-Checkout');
      if (checkoutButton) {
        checkoutButton.addEventListener('click', function () {
          showOverlay();
        });
      }
      console.log("snake-border-button")
  
      // Attach a shadow root with mode 'open'
      const shadow = this.attachShadow({ mode: 'open' });
  
      // Set default role if not provided
      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }
  
      // Ensure the element is focusable
      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }
  
      // Add keyboard event handling
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
  
      // Add template content to the shadow root
      shadow.innerHTML = `
        <style>
          :host {
            display: inline-block;
            position: relative;
            border-radius: 5px;
            outline: 1px solid #3B3529;
            outline-offset: -1.5px;
            cursor: pointer;
            text-transform: uppercase;
            box-sizing: border-box;
            overflow: hidden;
          }
  
          :host > span {
            border-radius: 50px;
          }
  
          span {
            position: absolute;
            z-index: 2;
            background: var(--gold-gradient);
          }
  
          span.top {
            top: 0;
            left: 0;
            width: 100%;
            height: 2px;
            animation: topAnimation 4s linear infinite;
            transform: translateX(100%);
          }
  
          @keyframes topAnimation {
            0% { transform: translateX(100%); }
            3% { transform: translateX(70%); }
            12% { transform: translateX(70%); }
            15% { transform: translateX(75%); }
            24% { transform: translateX(75%); }
            28% { transform: translateX(100%); }
            100% { transform: translateX(100%); }
          }
  
          span.right {
            top: 0;
            right: 0;
            width: 2px;
            height: 100%;
            animation: rightAnimation 4s linear infinite;
            transform: translateY(-100%);
          }
  
          @keyframes rightAnimation {
            0% { transform: translateY(-100%); }
            3% { transform: translateY(-50%); }
            12% { transform: translateY(-50%); }
            18% { transform: translateY(-55%); }
            25% { transform: translateY(0%); }
            28% { transform: translateY(0%); }
            35% { transform: translateY(60%); }
            38% { transform: translateY(60%); }
            50% { transform: translateY(100%); }
            100% { transform: translateY(100%); }
          }
  
          span.bottom {
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;
            animation: bottomAnimation 4s linear infinite;
            animation-delay: 2s;
            transform: translateX(-100%);
          }
  
          @keyframes bottomAnimation {
            0% { transform: translateX(-100%); }
            3% { transform: translateX(-70%); }
            12% { transform: translateX(-70%); }
            15% { transform: translateX(-75%); }
            24% { transform: translateX(-75%); }
            28% { transform: translateX(-100%); }
            100% { transform: translateX(-100%); }
          }
  
          span.left {
            top: 0;
            left: 0;
            width: 2px;
            height: 100%;
            animation: leftAnimation 4s linear infinite;
            animation-delay: 2s;
            transform: translateY(100%);
          }
  
          @keyframes leftAnimation {
            0% { transform: translateY(100%); }
            3% { transform: translateY(50%); }
            12% { transform: translateY(50%); }
            18% { transform: translateY(55%); }
            25% { transform: translateY(0%); }
            28% { transform: translateY(0%); }
            35% { transform: translateY(-60%); }
            38% { transform: translateY(-60%); }
            50% { transform: translateY(-100%); }
            100% { transform: translateY(-100%); }
          }
  
          /* Mimicking ::before */
          .before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: var(--gold-gradient);
            animation: cornerHelperTopAnimation 4s linear infinite;
            animation-delay: 2s;
            transform: translateX(-100%);
          }
  
          @keyframes cornerHelperTopAnimation {
            0% { transform: translateX(-100%); }
            22% { transform: translateX(-100%); }
            25% { transform: translateX(-70%); }
            35% { transform: translateX(-85%); }
            38% { transform: translateX(-85%); }
            50% { transform: translateX(-100%); }
            100% { transform: translateX(-100%); }
          }
  
          /* Mimicking ::after */
          .after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: var(--gold-gradient);
            animation: cornerHelperBottomAnimation 4s linear infinite;
            transform: translateX(100%);
          }
  
          @keyframes cornerHelperBottomAnimation {
            0% { transform: translateX(100%); }
            22% { transform: translateX(100%); }
            25% { transform: translateX(70%); }
            35% { transform: translateX(85%); }
            38% { transform: translateX(85%); }
            50% { transform: translateX(100%); }
            100% { transform: translateX(100%); }
          }
  
          .text {
            position: relative;
            z-index: 1;
          }
        </style>
  
        <span class="before"></span>
        <span class="top"></span>
        <span class="right"></span>
        <span class="bottom"></span>
        <span class="left"></span>
        <span class="after"></span>
        <slot></slot>
      `;
    }
  }
  
  customElements.define('snake-border-button', SnakeBorderButton);